import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { getAllExceptionList } from '../../actions/actionType/services/ServiceActionTypes';

import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IAllExceptionList, IExceptionQueryPrams } from '../../../models/index';
import { exceptionListSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { getAllExceptionListFailure, getAllExceptionListStarted, getAllExceptionSuccess } from '../../actions/sagaActions/exceptions/ExceptionListSagaAction';
import { FetchAllExceptionListRequest } from '../../actions/types/exceptions/FetchAllExceptionListTypes';
import { FetchExceptionFailurePayload } from '../../actions/types/exceptions/FetchExceptionTypes';

/**
 * Call Gets Schemas by ID API
 * @param schemaName : string
 * @returns api response
 */
export async function callFetchAllExceptionListApi(pageNo: number, item: number, queryParams?: IExceptionQueryPrams, sort?: string) {
  const urlString = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/exceptions/search?page=${pageNo}&size=${item}&sort=${sort}`;
  return apiWrapper.post<IAllExceptionList>(
    urlString,
    queryParams,
    headersInstance()
  );
}
/**
 * Saga to get Schema by schemaName
 * @param schemaName:string
 */
export function* fetchAllExceptionList({ pageNo, item, queryParams, sort }: FetchAllExceptionListRequest) {
  yield put(getAllExceptionListStarted());
  try {
    const { responseBody: exceptions, isError, error } = yield call(callFetchAllExceptionListApi, pageNo, item, queryParams, sort);
    const resValidity = exceptionListSchema.validate(exceptions, { abortEarly: true });
    if (isError) {
      throw error;
    }
    if (exceptions) {
      if (resValidity.error) {
        throw new Error('No Response');
      } else {
        yield put(getAllExceptionSuccess(exceptions));
      }
    } else throw new Error('No Response');
  } catch (error) {
    const obj: FetchExceptionFailurePayload = {
      error: String(error)
    };
    yield put(getAllExceptionListFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchAllExceptionListSaga() {
  yield takeLatest(getAllExceptionList.FETCH_ALL_EXCEPTION_LIST_REQUEST, fetchAllExceptionList);
}

export const getAllExceptionListSaga = [fork(fetchAllExceptionListSaga)];
